export default __webpack_public_path__ + "static/media/mail.c4cc08c9.svg";